// ignore-string-externalization

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  loadBlog,
  LoadBlogPayload,
  selectBlogCategories,
  selectBlogPosts,
} from '../../shared/store/blog';
import BlogSection from './BlogSection';
import { Spacer } from '../styles';

type Props = {
  loadBlog: (loadBlogPayload: LoadBlogPayload) => void;
  preview?: boolean;
  blogCategories?: {
    bySlug: {
      [key: string]: {
        name: string;
      };
    };
    nameToSlug: {
      [key: string]: string;
    };
    allSlugs: string[];
  };
};

class Blog extends Component<Props> {
  render() {
    if (!this.props.blogCategories) {
      return <></>;
    }

    return (
      <Fragment>
        <Spacer />

        {/* Content */}
        <div className="container">
          <BlogSection />
        </div>
      </Fragment>
    );
  }
}

const selector = createStructuredSelector({
  blogCategories: selectBlogCategories,
  blogPosts: selectBlogPosts,
});

const actions = { loadBlog };

export default connect(selector, actions)(Blog);
